/* @flow @format */

import { combineEpics, ofType } from 'redux-observable';
import { from } from 'rxjs';
import { map, mapTo, mergeMap, switchMap } from 'rxjs/operators';
import { push } from 'connected-react-router';

import type { ActionType } from '../utils';
import type { ObservableAction } from './types';
import { catchWith, getData } from './utils';
import { fetchAgreementBegin, fetchAgreementFailure, fetchAgreementSuccess } from '../reducer/term';
import { loadProfileSuccess } from '../reducer/profile';
import { signinBegin, signinFailure, signinSuccess } from '../reducer/auth';
import api from '../../graphql/api';

export function fetchAgreementEpic(action$: ObservableAction): ObservableAction {
  return action$.pipe(
    ofType<ActionType<typeof fetchAgreementBegin>>(fetchAgreementBegin.type),
    switchMap(({ payload }) =>
      from(api.fetchAgreement(payload)).pipe(
        getData(),
        map(data => data.collaborationV2),
        map(fetchAgreementSuccess),
        catchWith(fetchAgreementFailure, payload)
      )
    )
  );
}

export function signinEpic(action$: ObservableAction): ObservableAction {
  return action$.pipe(
    ofType<ActionType<typeof signinBegin>>(signinBegin.type),
    switchMap(({ payload }) =>
      from(api.ticketSignin(payload)).pipe(
        getData(),
        map(data => data.ticketAccountSigninV3),
        mergeMap(({ examineeProfile, ...auth }) => from([loadProfileSuccess(examineeProfile), signinSuccess(auth)])),
        catchWith(signinFailure, payload)
      )
    )
  );
}

const rediretToHomeAction = push('/');
export function signinSuccessRedirectEpic(action$: ObservableAction): ObservableAction {
  return action$.pipe(ofType<ActionType<typeof signinSuccess>>(signinSuccess.type), mapTo(rediretToHomeAction));
}

export default combineEpics(fetchAgreementEpic, signinEpic, signinSuccessRedirectEpic);
